import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Ellipse from '@bubble-ui/primitive-ellipse';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationFast = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationFast',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F45FF6",
    fillRule: "evenodd",
    d: "M24.195 33.382h-7.442v5.27h4.181a45.527 45.527 0 0 1 3.261-5.27Zm-5.997 11.596H4.468v5.27h12.284a43.717 43.717 0 0 1 1.446-5.27Zm-2.287 11.596H0v5.27h15.914a44.274 44.274 0 0 1-.003-5.27Zm.849 11.596H4.468v5.27h13.744a43.73 43.73 0 0 1-1.452-5.27Zm4.195 11.596h-5.318v5.27h8.587a45.561 45.561 0 0 1-3.269-5.27Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m85.209 18.053-7.62-3.323-3.52 8.073C54.922 15.891 33.41 24.872 25.031 43.77c-8.763 19.763.154 42.887 19.917 51.65 19.763 8.763 42.887-.154 51.65-19.917 8.006-18.056 1.254-38.918-15.043-49.07l3.654-8.38Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_28405_76213)",
    fillRule: "evenodd",
    d: "m85.209 18.053-7.62-3.323-3.52 8.073C54.922 15.891 33.41 24.872 25.031 43.77c-8.763 19.763.154 42.887 19.917 51.65 19.763 8.763 42.887-.154 51.65-19.917 8.006-18.056 1.254-38.918-15.043-49.07l3.654-8.38Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8FEAFF",
    d: "M90.772 49.398C85.117 32.853 67.12 24.025 50.576 29.679c-16.545 5.655-25.373 23.65-19.718 40.196 5.654 16.544 23.65 25.373 40.195 19.718 16.545-5.654 25.373-23.65 19.719-40.195Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_28405_76213)",
    d: "M90.772 49.398C85.117 32.853 67.12 24.025 50.576 29.679c-16.545 5.655-25.373 23.65-19.718 40.196 5.654 16.544 23.65 25.373 40.195 19.718 16.545-5.654 25.373-23.65 19.719-40.195Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9E58FF",
    d: "M78.66 68.502a1.997 1.997 0 0 1 2.674-.912l3.585 1.76a1.997 1.997 0 1 1-1.761 3.586l-3.585-1.761a1.997 1.997 0 0 1-.912-2.673ZM51.93 77.622a1.997 1.997 0 0 1 .912 2.673l-1.76 3.585a1.997 1.997 0 1 1-3.586-1.76l1.761-3.586a1.997 1.997 0 0 1 2.673-.912ZM69.138 42.212a2.154 2.154 0 0 1-1.009-2.875l1.867-3.884a2.154 2.154 0 1 1 3.884 1.866l-1.866 3.885a2.154 2.154 0 0 1-2.876 1.008ZM43.524 51.2a2.154 2.154 0 0 1-2.875 1.01l-3.884-1.867a2.154 2.154 0 1 1 1.866-3.884l3.884 1.867a2.154 2.154 0 0 1 1.009 2.875Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#56CFEB",
    fillRule: "evenodd",
    d: "M31.8 72.302a31.53 31.53 0 0 1 1.524-21.447c7.087-15.983 25.79-23.195 41.773-16.108A31.545 31.545 0 0 1 91.28 51.022c-2.477-8.741-8.678-16.357-17.632-20.327-15.984-7.087-34.686.125-41.773 16.109-3.745 8.445-3.498 17.65-.074 25.498Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#56CFEB",
    d: "M59.815 57.653c1.486-.715 12.99-3.956 19.92-5.88 1.07-.298 1.742 1.097.842 1.748-5.828 4.215-15.539 11.183-17.024 11.898a4.31 4.31 0 1 1-3.738-7.766Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#2A44C6",
    d: "M59.367 55.602c1.538-.593 13.265-2.9 20.327-4.26 1.091-.21 1.648 1.234.699 1.81-6.148 3.733-16.387 9.898-17.925 10.492a4.31 4.31 0 0 1-3.102-8.042Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#647EFD",
    fillRule: "evenodd",
    d: "M94.379 17.08 71.753 7.215l-3.01 6.904c-.559 1.28 4.054 4.525 10.302 7.25 6.248 2.725 11.765 3.896 12.323 2.617l3.01-6.904Z"
  }), /*#__PURE__*/React.createElement(Ellipse, {
    cx: 83.066,
    cy: 12.148,
    fill: "#5B76FC",
    rx: 12.342,
    ry: 2.527,
    transform: "rotate(23.56 83.066 12.148)"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_28405_76213",
    x1: 113.68,
    x2: 177.04,
    y1: -68.276,
    y2: 41.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.035,
    stopColor: "#ACE9FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.921,
    stopColor: "#3959F7"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_28405_76213",
    x1: 100.71,
    x2: 61.407,
    y1: 29.294,
    y2: 109.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.998,
    stopColor: "#5CE0FF"
  }))));
};
ColoredIllustrationFast.displayName = 'ColoredIllustrationFast';
export default withProvisionalOverrideFromContext(ColoredIllustrationFast);
//# sourceMappingURL=index.js.map